import { onLCP, onCLS, onINP, onTTFB } from "web-vitals";
import logger from "@/lib/logger";

type Metric = {
  name: string;
  value: number;
  rating: "good" | "needs-improvement" | "poor";
};

function sendToAnalytics(metric: Metric) {
  // Log to console for development
  logger.log("WEB_VITAL:", metric.name, metric.value, `(${metric.rating})`);

  // Send to GTM dataLayer for all analytics tracking
  if (typeof window !== "undefined" && (window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: "web_vitals",
      web_vital_name: metric.name,
      web_vital_value: metric.value,
      web_vital_rating: metric.rating,
      web_vital_delta: metric.value,
    });
  }

  // Send to Sentry as performance data
  if (window.Sentry) {
    window.Sentry.addBreadcrumb({
      category: "performance",
      message: `${metric.name}: ${metric.value}`,
      level: "info",
      data: {
        value: metric.value,
        rating: metric.rating,
      },
    });
  }

  // Store for potential API export
  const vitals = (window as any).__webVitals || [];
  vitals.push({
    ...metric,
    timestamp: Date.now(),
    url: window.location.href,
  });
  (window as any).__webVitals = vitals;
}

// Inicializar tracking de Web Vitals
onLCP(sendToAnalytics);
onCLS(sendToAnalytics);
onINP(sendToAnalytics);
onTTFB(sendToAnalytics);

// Exportar para posible consumo por API
export const getWebVitals = () => (window as any).__webVitals || [];
